import { Http } from '@mygpt/app/http';

export interface PromptVersion {
  id: string;
  version: number;
  prompt: string;
  prompt_type: 'main' | 'realtime' | 'phone';
  change_summary: string | null;
  source: 'manual' | 'ai_optimization' | 'rollback';
  is_active: boolean;
  created_at: string;
}

export interface PromptVersionListResponse {
  items: PromptVersion[];
  total: number;
}

export interface CreatePromptVersionParams {
  prompt: string;
  prompt_type: string;
  change_summary?: string;
  source: string;
}

export const listPromptVersions = async (
  aiId: string,
  promptType: string,
  page = 1,
  size = 20
): Promise<PromptVersionListResponse> => {
  const { get } = Http.use();
  const response = await get<PromptVersionListResponse>(`/v1/ais/${aiId}/prompt_versions`, {
    params: { prompt_type: promptType, page, size },
  });
  return response.data;
};

export const createPromptVersion = async (aiId: string, data: CreatePromptVersionParams): Promise<PromptVersion> => {
  const { post } = Http.use();
  const response = await post<PromptVersion>(`/v1/ais/${aiId}/prompt_versions`, data);
  return response.data;
};

export const activatePromptVersion = async (aiId: string, versionId: string): Promise<PromptVersion> => {
  const { post } = Http.use();
  const response = await post<PromptVersion>(`/v1/ais/${aiId}/prompt_versions/${versionId}/activate`);
  return response.data;
};

export const deletePromptVersion = async (aiId: string, versionId: string): Promise<void> => {
  const { delete: del } = Http.use();
  await del(`/v1/ais/${aiId}/prompt_versions/${versionId}`);
};
